<div class="theme">
  <div class="theme__label">
    {{ 'components.theme.labels.description' | translate }}
  </div>
  <app-theme-switcher></app-theme-switcher>
</div>
